import { render, staticRenderFns } from "./simOpen6.vue?vue&type=template&id=4ac8b578&scoped=true&"
import script from "./simOpen6.vue?vue&type=script&lang=js&"
export * from "./simOpen6.vue?vue&type=script&lang=js&"
import style0 from "./simOpen6.vue?vue&type=style&index=0&id=4ac8b578&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac8b578",
  null
  
)

export default component.exports